import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from '../styles';

import {SatisfactionAnalysisCards} from './SatisfactionAnalysisCards';
import {CultureAnalysisPdfContext} from '../../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {empionOrangeGradient} from '../../../../layouts/theme/designSystem';
import {SATISFACTION_QUESTION_LABELS} from '../../../../lib/pdf-constants';

export const SatisfactionAnalysisFirstPage = () => {
  const {t} = useTranslation('pdfDomain');

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const satisfactionAnalysisData = data.cultureSatisfaction;

  // The lables are currently not provided by the BE, hence importing them from the pdf-constants
  const combinedData = SATISFACTION_QUESTION_LABELS.map((label) => {
    const correspondingData = satisfactionAnalysisData.find((data) => data.key === label.key);

    return {
      ...label,
      data: correspondingData,
    };
  });

  // Here we are only taking the first 3 questions
  const questions = combinedData.slice(0, 3);

  return (
    <>
      <Grid container>
        <Grid container sx={{background: empionOrangeGradient.dark}} height={'290px'} p={5}>
          <Typography variant='h1' sx={pdfH1} mb={3}>
            {t('satisfactionAnalysis.title')}
          </Typography>
          <Typography variant='h1' sx={pdfH1} mb={3} ml={1}>
            1/3
          </Typography>

          <Typography
            sx={{
              ...bodyPdf,
              mb: 1,
              columnCount: 2,
              columnGap: '2em',
            }}
          >
            {t('satisfactionAnalysis.textBlock')}
          </Typography>
        </Grid>

        <Grid item container px={5} mt={10}>
          <SatisfactionAnalysisCards cardData={questions} />
        </Grid>
      </Grid>
    </>
  );
};
